import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import styled, { css } from 'styled-components';

import Helper from '../helper';
import Typography from '../typography';

interface QuestionMarkHelperProps {
  className?: string;
  id: string;
  isMobile: boolean;
  moveRight?: boolean;
  background?: string;
  color?: string;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const QuestionMarkHelper: FunctionComponent<QuestionMarkHelperProps> = ({
  className,
  id,
  children,
  isMobile,
  moveRight,
  background,
  color,
}) => {
  const [hasHelper, setHasHelper] = React.useState<string>('');
  return (
    <div style={{ position: 'relative' }}>
      <QuestionMark
        className={className || ''}
        onMouseEnter={() => setHasHelper(id)}
        onMouseLeave={() => setHasHelper('')}
        onTouchStart={() => setHasHelper(id)}
        onTouchCancel={() => setHasHelper('')}
        backgroundColor={background}
        fontColor={color}
      >
        <Typography weight="700">?</Typography>
      </QuestionMark>
      <Helper
        textLeft
        moveRight={moveRight}
        noArrow={isMobile}
        isHover={hasHelper === id}
      >
        {children}
      </Helper>
    </div>
  );
};

export default connect(mapStateToProps)(QuestionMarkHelper);

const QuestionMark = styled.div<{
  backgroundColor?: string;
  fontColor?: string;
}>`
  border-radius: 50%;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: help;

  span {
    font-size: ${({ theme }) => theme.typography.small};
    ${({ fontColor }) =>
      fontColor
        ? css`
            color: ${fontColor};
          `
        : css`
            color: ${({ theme }) => theme.colors.background};
          `}
  }

  ${({ backgroundColor }) =>
    backgroundColor
      ? css`
          background-color: ${backgroundColor};
        `
      : css`
          background-color: ${({ theme }) => theme.colors.primary};
        `}
`;
